import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MultiLangPipe } from 'src/core/pipes/multi-lang.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CategoriesSelectionDialogComponent } from './dialogs/categories-selection/categories-selection.dialog';
import { CreateUserDialogComponent } from './dialogs/create-user/create-user.dialog';
import { EditUserDialogComponent } from './dialogs/edit-user/edit-user.dialog';
import { PdfsDialogComponent } from './dialogs/pdfs/pdfs.dialog';
import { PromtDialogComponent } from './dialogs/promt-dialog/promt.dialog';
import { RegisterSuccessDialogComponent } from './dialogs/registerSuccess/registerSuccess.dialog';
import { RestorePasswordDialogComponent } from './dialogs/restorePassword/restorePassword.dialog';
import { SliderItemDialogComponent } from './dialogs/slider-item/slider-item.dialog';
import { SliderSelectionDialogComponent } from './dialogs/slider-selection/slider-selection.dialog';
import { TagsDialogComponent } from './dialogs/tags/tags.dialog';
import { UsersImportDialogComponent } from './dialogs/users-import/users-import.dialog';
import { MaterialModule } from './material.module';

@NgModule({
    declarations: [
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        RegisterSuccessDialogComponent,
        RestorePasswordDialogComponent,
        MultiLangPipe,
        PromtDialogComponent,
        CreateUserDialogComponent,
        TagsDialogComponent,
        CategoriesSelectionDialogComponent,
        PdfsDialogComponent,
        SliderItemDialogComponent,
        SliderSelectionDialogComponent,
        UsersImportDialogComponent,
        EditUserDialogComponent
    ],
    exports: [
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        MultiLangPipe
    ],
    imports: [
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FlexLayoutModule,
        TranslateModule,
    ]
})
export class SharedModule { }
